import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import TestingForm from '../../components/features/testing/TestingForm/TestingForm'
import {ProgressCounter, TestInnerContainer, TestTop, TestWrap} from './styles';
import { basicColor, testBackground } from '@/styles/template'
import QuizProgressBar from '../../components/molecules/QuizProgressBar/QuizProgressBar'
import {ArticleH2} from '../designSystem/Fonts'
import TestButtonBar from '../../components/features/testing/TestButtonBar/TestButtonBar'
import {useDispatch, useSelector} from 'react-redux'
import {sendLikes, setLikesLocalStorageKey, setLikesData, resetLikesState} from '@/store/reducers/likesSlice.js'
import {
    getTest,
    resetTestingState, setIsTesting, setValidityKey,
} from '@/store/reducers/testingSlice.js'

import {
    calculateDuration,
    getDurationsFromLocalStorage, resetDurationsState,
    setDurationLocalStorageKey,
} from '@/store/reducers/durationSlice.js'

import AdTestProcess from '../../components/features/adv/AdTestProcess/AdTestProcess'
import Loader from '../../components/atoms/UI/Loader/Loader'
import SmartCloseBackButton from '../../components/molecules/SmartCloseBackButton/SmartCloseBackButton'
import {
    checkIfLocalStorageDoesNotContainCurrentState
} from '../../core/utils/checkIfLocalStorageDoesNotContainCurrentState';
import { fetchResult, postResults, resetResult } from '@/store/reducers/resultSlice';
import { AppDispatch } from '@/store/store';
import { selectAttemptKey } from '@/store/selectors/selectAttemptKey';
import { selectResultData, selectResultDescription, selectResultError } from '@/store/selectors/resultSelectors';
import Result from '@/pages/result/Result';
import { StyledExitIcon } from '@/components/atoms/UI/ExitButton/styles';
import TestingStyles from '@/prod/testing/styles';
import ErrorWithReload from '@/components/molecules/ErrorWithReload/ErrorWithReload';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';

type TestingProps = { clickedBtn?: string }

const Testing: React.FC<TestingProps> = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const clickedBtnFromState = location.state?.clickedBtn;
    const resultError = useSelector(selectResultError);
    const fromAttempt = location.state?.fromAttempt;
    const forceStart = location.state?.forceStart;
    const clickedBtn = props.clickedBtn || clickedBtnFromState || (fromAttempt ? 'clearAndStart' : '');
    // console.log('clickedBtnFromState', clickedBtnFromState)
    // console.log('props.clickedBtn', props.clickedBtn)
    // console.log('Testing', clickedBtn)

    const dispatch: AppDispatch = useDispatch();
    const hasLoggedRef = useRef(false);
    const attemptKey = useSelector(selectAttemptKey);
    const {
        testData,
        activeQuestion,
        isFinished,
        error,
        testId,
        answers,
        background,
        additional,
        localStorageKey: answersDataKey,
        isFetching,
    } = useSelector((state: any) => state.testing)
    const currentQuestionNextBtnShow: any = testData[activeQuestion]?.question?.nextBtnShow;
    const backgroundColor =  testBackground[background];
    const likes = useSelector((state: any) => state.likes.likes);
    const middleOfTest = Math.floor(testData.length / 2);
    const percent = isFinished ? 100 : (100 * activeQuestion / testData.length);
    const likesDataKey = `test_${testId}_likes`;
    const durationDataKey = `test_${testId}_durations`;
    const validityKey = `test_${testId}_validity`;

    const resetState = () => {
        localStorage.removeItem(likesDataKey);
        localStorage.removeItem(answersDataKey);
        localStorage.removeItem(durationDataKey);
        localStorage.removeItem(validityKey);
        dispatch(resetDurationsState());
        dispatch(resetTestingState());
        dispatch(resetLikesState());

    }

    // useEffect(() => {
    //     // Очистить navigate state
    //     navigate(location.pathname, {
    //         replace: true,
    //         state: {} // очищаем все состояние
    //     });
    // }, [location.pathname, navigate]);



    useLayoutEffect(() => {
        // console.log('useLayoutEffect')

        if (forceStart || clickedBtn === 'clearAndStart' || (clickedBtn === 'clear')) {
            resetState();
            dispatch(resetResult());
        }

        if (clickedBtn !== 'lastAttempt') {
            dispatch(getTest());
        }
    }, [clickedBtn, dispatch, forceStart, testId]);

    // ======== Устанавливаем цвет фона body ========
    useEffect(() => {
        const originalBackground = document.body.style.background;
        document.body.style.background = backgroundColor;

        return () => {
            document.body.style.background = originalBackground;
        };
    }, [backgroundColor]);

    useEffect(() => {
        dispatch(resetResult());
        if (testId) {
            dispatch(setLikesLocalStorageKey(likesDataKey));
            dispatch(setDurationLocalStorageKey(durationDataKey));
            dispatch(setValidityKey(validityKey));

            if (localStorage.getItem(durationDataKey)) {
                dispatch(getDurationsFromLocalStorage(durationDataKey));
            }
        }
    }, [testId]);

    // ======== Если testId есть, сеттим лайки и проверяем, нужно ли постить результат ========
    useEffect(() => {
        if (testId) {
            dispatch(setLikesData(likesDataKey));

            if (answers.length === testData.length && testData.length > 0 && !currentQuestionNextBtnShow) {
                dispatch(postResults(answers));
            }
        }
    }, [activeQuestion, testId])

    // ======== Считаем время (duration) пока не получен attemptKey и не закончен тест ========
    useEffect(() => {
        if (!attemptKey && !isFinished) {
            return dispatch(calculateDuration(activeQuestion))
        }
    }, [activeQuestion, isFinished, attemptKey]);

    useEffect(() => {
        checkIfLocalStorageDoesNotContainCurrentState(likesDataKey, likes)
        checkIfLocalStorageDoesNotContainCurrentState(answersDataKey, answers)
    }, [activeQuestion]);

    // ========  Если тест завершён, postResults ========
    useEffect(() => {
        if (isFinished) {
            dispatch(postResults(answers));
        }
    }, [isFinished]);

    // ======== Если теперь появился attemptKey (значит, результат зафиксирован) ========
    // Сбрасываем локальное состояние и отправляем лайки
    useEffect(() => {
        if(attemptKey) {
            if(likes.length > 0) {
                dispatch(sendLikes(likes, attemptKey));
            }
            resetState();
        }
    }, [attemptKey])

    // ========  Рендер рекламы fullscreen при середине теста ========
    useEffect(() => {
        if (testData.length >= 6 && !hasLoggedRef.current ) {
            if (activeQuestion === middleOfTest) {
                hasLoggedRef.current = true;

                if(additional.blocks.processAdvFullscreen.show){
                    //@ts-ignore
                    window.yaContextCb.push(()=>{
                        //@ts-ignore
                        Ya.Context.AdvManager.render({
                            type: 'fullscreen',
                            platform: 'touch',
                            blockId: 'R-A-266642-29'
                        })})
                }
            } else {
                hasLoggedRef.current = false;
            }
        }
    }, [activeQuestion, middleOfTest])

    if (attemptKey || clickedBtn === 'lastAttempt') {
        return <Result fromAttempt={false} clickedBtn={clickedBtn}  />;
    }

    if (resultError) {
        return <ErrorWithReload error={resultError} transparent />
    }

    return (
        <TestWrap style={{background: backgroundColor}} >
            <TestingStyles />
            <TestTop>
                <ProgressCounter><ArticleH2><span>{activeQuestion + 1}</span> / {testData.length}</ArticleH2></ProgressCounter>
                <SmartCloseBackButton><StyledExitIcon name='Close' size={9} testing /></SmartCloseBackButton>
            </TestTop>

            <TestInnerContainer>
                {(isFetching || isFinished) ? <Loader />
                    : error ? <ErrorWithReload error={error} transparent />
                    : <TestingForm />
                }
                {additional.blocks.processAdvBottom.show && testId && (
                    <>
                        <AdTestProcess testId={testId} country={additional.device.country} />
                    </>

                )}
            </TestInnerContainer>

            {!error && <TestButtonBar cssBack={backgroundColor}/>}
            <QuizProgressBar percent={percent}/>
        </TestWrap>
    )
}
export default Testing

